module.exports = __webpack_public_path__ + "static/media/gameVideo2.7e35a2f8.mp4";